import React, { Component } from "react";
import { PictureAsPdf, Description, MoreHoriz } from "@material-ui/icons";
import { Menu, MenuItem } from "@material-ui/core";
import { OuterWrapper, FileWrapper, SubTitleWrapper } from "./DrawerAttachmentsItemStyles";
import FileRenameModal from './FileRenameModal';

export default class DrawerAttachmentsItem extends Component {
  constructor() {
    super();
    this.state = { menuAnchorElement: null,
    isRenameModalOpen: false};
  }

  handleOpen = () => {
    if (this.isFilePdf() && this.props.referenceMode) {
      this.props.onOpenPdfForReference(this.props.file);
      this.setState({ menuAnchorElement: null });
    }
  };

  handleDownload() {
    this.props.onDownload();
    this.setState({ menuAnchorElement: null });
  }

  handleRename = () => {
    this.setState({isRenameModalOpen: true});
  }

  renameFile = (fileName) => {
    this.props.onUpdate(fileName);
    this.setState({ menuAnchorElement: null });
    this.closeModal();
  }

  closeModal = () => {    
    this.setState({isRenameModalOpen: false});
  }

  handleDelete = () =>{
    this.props.onRemove(this.props.file);
    this.setState({ menuAnchorElement: null });
  }

  handleTogglePublic() {
    const newFile = { ...this.props.file, isPrivate: !this.props.file.isPrivate };
    this.props.onUpdate(newFile);
    this.setState({ menuAnchorElement: null });
  }

  isFilePdf = () => this.props.file.name.toUpperCase().endsWith(".PDF");

  renderReferenceDescription = () => {
    if(this.props.referencedFieldPath && this.props.referenceFields) {
      const matchedReferenceFields = this.props.referenceFields.filter(referenceField => referenceField.path === this.props.referencedFieldPath);
      if (matchedReferenceFields.length === 0) {
        throw new Error(`Could not find reference field "${this.props.referencedFieldPath}"`);
      }
      const currentField = matchedReferenceFields[0];
  
      const referenceCount = this.props.references.filter(reference => reference.referenceField.path === this.props.referencedFieldPath && reference.fileLinkId === this.props.file.id).length;
      if(referenceCount === 1) {
        return (<SubTitleWrapper>{`1 reference to ${currentField.name}`}</SubTitleWrapper>);
      } else if(referenceCount > 1) {
        return (<SubTitleWrapper>{`${referenceCount} references to ${currentField.name}`}</SubTitleWrapper>);
      } else {
        return '';
      }
    }
     return '';
  };

  render() {
    return (
      <OuterWrapper isPrivate={this.props.file.isPrivate}>
        <div style={{display:"flex", flexDirection: "row"}}>
        {this.isFilePdf() && <PictureAsPdf style={{ fill: "#0F9AD6" }} />}
        {!this.isFilePdf() && <Description style={{ fill: "#0F9AD6" }} />}
        <FileWrapper onClick={() => this.handleOpen()} name={`attachmentNamed${this.props.file.name}`} cursorPointer={this.isFilePdf() && this.props.referenceMode}>{`${this.props.file.name} (${this.props.file.sizeLabel})`}</FileWrapper>
        {!this.props.file.isPrivate && (
          <div style={{ color: "#C40A0A", paddingRight: "10px", textTransform: "uppercase", fontSize: "12px", fontWeight: "600" }}>public</div>
        )}
        <MoreHoriz onClick={event => this.setState({ menuAnchorElement: event.currentTarget })} />

        <Menu anchorEl={this.state.menuAnchorElement} open={Boolean(this.state.menuAnchorElement)} onClose={() => this.setState({ menuAnchorElement: null })}>
          <MenuItem onClick={() => this.handleDownload()}>Download</MenuItem>
          {!this.props.authentication.isGuest && <MenuItem onClick={() => this.handleRename()}>Rename</MenuItem>}
          {!this.props.authentication.isGuest && <MenuItem onClick={() => this.props.deleteAttachment ? this.props.deleteAttachment(this.handleDelete) : this.handleDelete()}>Delete</MenuItem>}
          {!this.props.authentication.isGuest && <MenuItem onClick={() => this.handleTogglePublic()}>Set as {this.props.file.isPrivate ? "public" : "private"}</MenuItem>}
        </Menu>
        </div>
        {this.renderReferenceDescription()}

        <FileRenameModal isOpen={this.state.isRenameModalOpen} onClose={this.closeModal} onAccept={this.renameFile} file={this.props.file} />
      </OuterWrapper>
    );
  }
}